import * as token from "app/localStorage/token"
import { redirectOldAppIfSwitched } from "app/switch/appSwitch"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { history } from "store"
import * as api from "../../api/oauth"
import * as actions from "./authentication.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* authenticationFlow(): SagaIterator {
  try {
    const response = yield call(api.authenticate)
    yield call(token.storeAccessToken, response && response.accessToken)
    yield call(token.storeIdToken, response && response.idToken)
    yield call(redirectOldAppIfSwitched)
    yield put(actions.authenticateSuccess())
    history.push("/")
  } catch (e) {
    yield call(api.logout)
    yield put(actions.authenticateFail(e))
    yield call(handleError, { error: e })
  }
}

export function* logoutFlow(): SagaIterator {
  try {
    yield call(token.clearLocalStorage)
    yield call(api.logout)
    yield put(actions.logoutSuccess())
  } catch (e) {
    yield put(actions.logoutFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* authenticationSaga(): SagaIterator {
  yield takeLatest(actions.Types.AUTHENTICATE, authenticationFlow)
  yield takeLatest(actions.Types.LOGOUT, logoutFlow)
}
